import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background: #faf3f0;
    font-family: Gill Sans, sans-serif;
  }
`;

export default GlobalStyle;